module.exports = __webpack_public_path__ + "img/Middle-Bevel-Attachment-18.df8613b3.png";